import { render, staticRenderFns } from "./HomeworkDiagnosis.vue?vue&type=template&id=0dd2b67e&scoped=true&"
import script from "./HomeworkDiagnosis.vue?vue&type=script&lang=js&"
export * from "./HomeworkDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkDiagnosis.vue?vue&type=style&index=0&id=0dd2b67e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd2b67e",
  null
  
)

export default component.exports